import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { LevelService } from './level/level.service';
import { SupervisorService } from './supervisor/supervisor.service';
import { ExamtypeService } from './examtype/examtype.service';
import { ClassSetService } from './class-set/class-set.service';
import { QuestiondifficultyService } from './questiondifficulty/questiondifficulty.service';
import { SubjectService } from './subject/subject.service';
import { map } from 'rxjs/operators';
import { ClassService } from './class/class.service';
import { DifficultymodifiersService } from './difficultymodifiers/difficultymodifiers.service';
import { StudentService } from './student/student.service';

@Injectable()
export class DataService {

  // private messageData = new BehaviorSubject([]);
  // currentMessage = this.messageData.asObservable();
  private dataClassList: BehaviorSubject<[]> = new BehaviorSubject([]);
  ClassList: Observable<[]> = this.dataClassList.asObservable();

  private dataLevelList: BehaviorSubject<[]> = new BehaviorSubject([]);
  LevelList: Observable<[]> = this.dataLevelList.asObservable();

  private dataSubjectList: BehaviorSubject<[]> = new BehaviorSubject([]);
  SubjectList: Observable<[]> = this.dataSubjectList.asObservable();

  private dataSupervisorList: BehaviorSubject<[]> = new BehaviorSubject([]);
  SupervisorList: Observable<[]> = this.dataSupervisorList.asObservable();

  private dataClassSetList: BehaviorSubject<[]> = new BehaviorSubject([]);
  ClassSetList: Observable<[]> = this.dataClassSetList.asObservable();

  private dataQuestionDifficultyList: BehaviorSubject<[]> = new BehaviorSubject([]);
  QuestionDifficultyList: Observable<[]> = this.dataQuestionDifficultyList.asObservable();

  private dataExamTypeList: BehaviorSubject<[]> = new BehaviorSubject([]);
  ExamTypeList: Observable<[]> = this.dataExamTypeList.asObservable();

  private dataModifierList: BehaviorSubject<[]> = new BehaviorSubject([]);
  ModifierList: Observable<[]> = this.dataModifierList.asObservable();

  private dataStudentList: BehaviorSubject<[]> = new BehaviorSubject([]);
  StudentList: Observable<[]> = this.dataStudentList.asObservable();

  constructor(private supervisorService: SupervisorService,
    private levelService: LevelService,
    private examTypeService: ExamtypeService,
    private classService: ClassService,
    private classSetService: ClassSetService,
    private questionDifficultyService: QuestiondifficultyService,
    private subjectService: SubjectService,
    private ModifierService: DifficultymodifiersService,
    private StudentService: StudentService,
  )
  { }

  // changeMessage(message: []) {
  //   this.messageData.next(message)
  // }

  getClassData(): Observable<any> {
    return this.classService.viewClass()
      .pipe(map(
        (data: any) => { return this.dataClassList.next(data); }
      ))
  }

  getLevelData(): Observable<any> {
    return this.levelService.viewLevel()
      .pipe(map(
        (data: any) => { this.dataLevelList.next(data); }
      ))
  }

  getSubjectData(): Observable<any> {
    return this.subjectService.viewSubject()
      .pipe(map(
        (data: any) => { this.dataSubjectList.next(data); }
      ))
  }

  getSupervisorData(): Observable<any> {
    return this.supervisorService.viewSupervisor()
      .pipe(map(
        (data: any) => { this.dataSupervisorList.next(data); }
      ))
  }

  getClassSetData(): Observable<any> {
    return this.classSetService.viewClassSet()
      .pipe(map(
        (data: any) => { this.dataClassSetList.next(data); }
      ))
  }

  getQuestionDifficultyData(): Observable<any> {
    return this.questionDifficultyService.viewQuestionDifficulty()
      .pipe(map(
        (data: any) => { this.dataQuestionDifficultyList.next(data); }
      ))
  }

  getExamTypeData(): Observable<any> {
    return this.examTypeService.viewExamType()
      .pipe(map(
        (data: any) => { this.dataExamTypeList.next(data); }
      ))
  }

  getModifierData(): Observable<any> {
    return this.ModifierService.viewModifier()
      .pipe(map(
        (data: any) => { this.dataModifierList.next(data);}
      ))
  }

  getStudentData(): Observable<any> {
    return this.StudentService.viewStudent()
      .pipe(map(
        (data: any) => { this.dataStudentList.next(data);}
      ))
  }
}
